export default __webpack_public_path__ + "static/media/MasterCard.ae6d4999.svg";